<template>
  <div class="search-box-container">
    <template v-for="(item, index) in opts">
      <van-row :key="index" :gutter="8" :type="rowLayout" v-if="item.length">
        <van-col
          :span="subItem.span"
          v-for="(subItem, subIndex) in item"
          :key="subIndex"
          :style="subItem.style"
        >
          <div
            class="normal-input-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            v-if="subItem.type === SEARCH_BOX_TYPE.NORMAL_INPUT"
          >
            <img
              src="@/assets/images/agent/search_s.png"
              alt=""
              class="search-icon"
            />
            <template v-if="subItem.inputType === INPUT_TYPE.NUMBER">
              <input
                oninput="value = value.replace(/[^\d]/g, '')"
                :type="subItem.inputType"
                v-model="subItem.searchValue"
                @focus="handleFocus(subItem)"
                @blur="handleBlur(subItem)"
                :placeholder="subItem.placeholder"
              />
            </template>
            <template v-else>
              <input
                :type="subItem.inputType"
                v-model="subItem.searchValue"
                @focus="handleFocus(subItem)"
                @blur="handleBlur(subItem)"
                :placeholder="subItem.placeholder"
              />
            </template>
            <div
              class="search-btn"
              v-if="subItem.searchValue && subItem.isFocused"
              @click="search"
            >
              搜索
            </div>
            <img
              src="@/assets/images/agent/search_close.png"
              alt=""
              class="close-icon"
              v-if="subItem.searchValue && !subItem.isFocused"
              @click="clear(subItem)"
            />
          </div>
          <div
            class="select-input-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            v-else-if="subItem.type === SEARCH_BOX_TYPE.SELECT_INPUT"
          >
            <CustomSelect
              :searchOpt="subItem"
              v-model="subItem.openSelect"
              @change="changeSelect"
              :selectList="subItem.options"
              :selectValue="subItem.selectValue"
            />
            <div class="line"></div>
            <template v-if="subItem.inputType === INPUT_TYPE.NUMBER">
              <input
                oninput="value = value.replace(/[^\d]/g, '')"
                :type="subItem.inputType"
                v-model="subItem.searchValue"
                @focus="handleFocus(subItem)"
                @blur="handleBlur(subItem)"
                :placeholder="placeholder(subItem)"
              />
            </template>
            <template v-else>
              <input
                :type="subItem.inputType"
                v-model="subItem.searchValue"
                @focus="handleFocus(subItem)"
                @blur="handleBlur(subItem)"
                :placeholder="placeholder(subItem)"
              />
            </template>
            <div
              class="search-btn"
              v-if="subItem.searchValue && subItem.isFocused"
              @click="search"
            >
              搜索
            </div>
            <img
              src="@/assets/images/agent/search_close.png"
              alt=""
              class="close-icon"
              v-if="subItem.searchValue && !subItem.isFocused"
              @click="clear(subItem)"
            />
          </div>
          <div
            class="select-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            v-else-if="
              subItem.type === SEARCH_BOX_TYPE.SELECT ||
              subItem.type === SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT ||
              subItem.type === SEARCH_BOX_TYPE.DATE_SELECT
            "
          >
            <CustomSelect
              :multiple="subItem.multiple"
              :labelOptions="subItem.labelOptions"
              :dateType="currentItem.dateType"
              v-model="subItem.openSelect"
              :placement="subItem.placement"
              :searchOpt="subItem"
              :selectList="subItem.options"
              :selectValue="subItem.selectValue"
              :selectLabelValue="subItem.selectLabelValue"
              :customDateStr="subItem.customDateStr"
              @change="changeSelect"
              @changeLabel="changeSelectLabel"
              @customDateChange="customDateChange(subItem, index, subIndex)"
            />
          </div>
          <div
            class="area-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            v-else-if="subItem.type === SEARCH_BOX_TYPE.AREA"
            @click="areaOpen(subItem, index, subIndex)"
          >
            <div class="area-text">
              {{ subItem.areaStr ? subItem.areaStr : '全部地区' }}
            </div>
            <img
              src="@/assets/images/agent/search_close.png"
              alt=""
              class="close-icon"
              v-if="subItem.areaStr"
              @click.stop="areaClear(subItem)"
            />
            <img src="@/assets/images/agent/select-arrow.png" />
          </div>
          <template v-else-if="subItem.type === SEARCH_BOX_TYPE.FILTER">
            <template v-if="filterNumber === 0">
              <div
                class="filter-box"
                :class="[subItem.smallSize ? 'small-size' : '']"
                @click="filterPanelVisible = true"
              >
                <div class="text-ellipsis">筛选</div>
                <img src="@/assets/images/agent/select-arrow.png" />
              </div>
            </template>
            <template v-else>
              <van-badge :content="filterNumber">
                <div
                  class="filter-box"
                  :class="[subItem.smallSize ? 'small-size' : '']"
                  @click="filterPanelVisible = true"
                >
                  <div class="text-ellipsis">筛选</div>
                  <img src="@/assets/images/agent/select-arrow.png" />
                </div>
              </van-badge>
            </template>
          </template>
          <div
            v-else-if="subItem.type === SEARCH_BOX_TYPE.RESET"
            class="reset-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            @click="resetClick"
          >
            <div class="text-ellipsis">重置</div>
          </div>
          <div
            v-else-if="subItem.type === SEARCH_BOX_TYPE.EXPORT"
            class="export-box"
            :class="[subItem.smallSize ? 'small-size' : '']"
            @click="exportBtn"
          >
            <div class="text-ellipsis">
              {{ subItem.exportLabel ? subItem.exportLabel : '导出' }}
            </div>
          </div>
          <div
            v-else-if="subItem.type === SEARCH_BOX_TYPE.EXTRA"
            :class="[
              subItem.smallSize ? 'small-size' : '',
              $slots[subItem.extraSlotName] ? 'extra-slot-box' : 'extra-box',
            ]"
            @click="extraCLick(subItem)"
          >
            <slot
              :name="subItem.extraSlotName"
              v-if="$slots[subItem.extraSlotName]"
            ></slot>
            <div v-else class="text-ellipsis">{{ subItem.btnLabel }}</div>
          </div>
        </van-col>
      </van-row>
    </template>
    <FilterPanelPopup
      ref="filterPanelPopupRef"
      @confirm="filterPanelPopupConfirm"
      @filterNumberChange="filterNumberChange"
      @changeOutSideBox="changeBox"
      v-model="filterPanelVisible"
    >
    </FilterPanelPopup>
    <CustomDateTimePopup
      :dateType="currentItem.dateType"
      v-model="dateTimePopup"
      :beginDate="currentItem.curCustomDate[0]"
      :overDate="currentItem.curCustomDate[1]"
      :limitDay="currentItem.limitDay"
      @confirm="handleConfirmDateTime"
      :sameYear="false"
    />
    <AreaBox v-model="areaVisible" @confirm="changeArea"></AreaBox>
  </div>
</template>

<script>
import CustomSelect from './components/CustomSelect.vue'
import FilterPanelPopup from './components/FilterPanelPopup.vue'
import AreaBox from './components/AreaBox.vue'
import moment from 'moment/moment'
import { cloneDeep, debounce } from 'lodash'
import CustomDateTimePopup from '@/pages/agent/components/CustomDateTimePopup.vue'
import {
  DATE_TYPE,
  FILTER_PANEL_OPT_TYPE,
  INPUT_TYPE,
  OTHER_TYPE,
  SEARCH_BOX_TYPE,
} from '@/components/VzanSearchBox/enum'
import { arraysAreEqual, formatStr } from '@/components/VzanSearchBox/utils'

import { mapGetters } from 'vuex'
export default {
  name: 'VzanSearchBox',
  components: { CustomDateTimePopup, FilterPanelPopup, CustomSelect, AreaBox },
  props: {
    rowLayout: {
      type: String,
      default: '',
    },
    searchOpts: {
      type: Array,
      default: () => [],
    },
    filterPanelOpts: {
      type: Array,
      default: () => [],
    },
    resetClickFn: {
      type: [Function, null],
      default: null,
    },
  },
  data() {
    return {
      INPUT_TYPE,
      SEARCH_BOX_TYPE,
      areaVisible: false,
      dateTimePopup: false,
      calcBeginDate: '',
      calcOverDate: '',
      filterNumber: 0,
      filterPanelVisible: false,
      filterPanelOptsData: [],
      opts: [],
      currentItem: {
        curCustomDate: [],
      },
      currentAreaItem: {},
      paramsResult: {},
      linkageMap: new Map(), // 存储联动的筛选项，用于联动
      optsPropsMap: new Map(), // 存储所有的筛选项，用于设置默认值
    }
  },
  watch: {
    opts: {
      handler(val) {
        // this.formatResult()
      },
      deep: true,
    },
    searchOpts: {
      handler() {
        this.init()
      },
      deep: true,
    },
    filterPanelOpts: {
      handler(val) {
        this.init()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['fontSizeScale']),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.onceInit()
      this.initData('init')
      this.$refs.filterPanelPopupRef.init(this.filterPanelOptsData)
    },
    // 只需初始化一次
    onceInit() {
      console.log('this.searchOpts', this.searchOpts)
      this.opts = cloneDeep(this.searchOpts).reduce((prev, cur) => {
        // 隐藏
        let filter = cur.filter(item => {
          return !item.hide
        })
        // 时间格式化格式
        cur.forEach(item => {
          if (
            [
              SEARCH_BOX_TYPE.DATE_SELECT,
              SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT,
            ].includes(item.type)
          ) {
            item.options.forEach(opt => {
              if (opt.value !== OTHER_TYPE.CUSTOM_DATE) {
                if (opt.value.length !== 0) {
                  opt.value = [
                    moment(opt.value[0]).format(formatStr(item.dateType)),
                    moment(opt.value[1]).format(formatStr(item.dateType)),
                  ]
                }
              } else {
                // 如果自定义 没给默认值自动给7天的自定义默认值
                opt.defaultBeginDate = opt.defaultBeginDate
                  ? moment(opt.defaultBeginDate).format(
                      formatStr(item.dateType)
                    )
                  : moment()
                      .subtract(7 - 1, 'days')
                      .format(formatStr(item.dateType))
                opt.defaultEndDate = opt.defaultEndDate
                  ? moment(opt.defaultEndDate).format(formatStr(item.dateType))
                  : moment().format(formatStr(item.dateType))
              }
            })
          }
        })
        cur.forEach(item => {
          this.saveOptsPropsMap(item)
        })
        prev.push(filter)
        return prev
      }, [])
      this.filterPanelOptsData = cloneDeep(this.filterPanelOpts).filter(
        // 隐藏
        item => {
          return !item.hide
        }
      )
    },
    saveOptsPropsMap(item) {
      switch (item.type) {
        case SEARCH_BOX_TYPE.NORMAL_INPUT:
          this.optsPropsMap.set(item.props, item)
          break
        case SEARCH_BOX_TYPE.SELECT_INPUT:
          item.options.forEach(opt => {
            this.optsPropsMap.set(opt.value, item)
          })
          break
        case SEARCH_BOX_TYPE.SELECT:
          this.optsPropsMap.set(item.props, item)
          break
        case SEARCH_BOX_TYPE.DATE_SELECT:
          this.optsPropsMap.set(item.props, item)
          break
        case SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT:
          item.labelOptions.forEach(opt => {
            this.optsPropsMap.set(opt.value, item)
          })
          break
        case SEARCH_BOX_TYPE.AREA:
          this.optsPropsMap.set(item.props, item)
          break
      }
    },
    // 初始化数据
    initData(source = 'init') {
      return new Promise(resolve => {
        this.opts.forEach(item => {
          item.forEach(subItem => {
            // 给默认配置添加字段
            this.$set(subItem, 'openSelect', false)
            this.$set(subItem, 'isFocused', false)
            this.$set(subItem, 'searchValue', '')
            if (subItem.defaultSearchValue) {
              this.$set(subItem, 'searchValue', subItem.defaultSearchValue)
            }
            // 处理默认项
            if (
              [
                SEARCH_BOX_TYPE.SELECT_INPUT,
                SEARCH_BOX_TYPE.SELECT,
                SEARCH_BOX_TYPE.DATE_SELECT,
                SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT,
              ].includes(subItem.type)
            ) {
              if (subItem.multiple) {
                this.$set(subItem, 'selectValue', [])
                subItem.options.forEach(opt => {
                  if (opt.default) {
                    subItem.selectValue.push(opt.value)
                  }
                })
              } else {
                let defaultSelectValue =
                  subItem.options.find(opt => opt.default) || subItem.options[0]
                if (defaultSelectValue) {
                  this.$set(subItem, 'selectValue', defaultSelectValue.value)
                  if (defaultSelectValue.defaultSearchValue) {
                    this.$set(
                      subItem,
                      'searchValue',
                      defaultSelectValue.defaultSearchValue
                    )
                  }
                  this.$set(
                    subItem,
                    'inputType',
                    defaultSelectValue.inputType ?? ''
                  )
                }
              }
            }
            // 多级联选择器
            if ([SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT].includes(subItem.type)) {
              let defaultSelectValue =
                subItem.labelOptions.find(opt => opt.default) ||
                subItem.labelOptions[0]
              this.$set(subItem, 'selectLabelValue', defaultSelectValue.value)
              this.$set(subItem, 'selectLabel', defaultSelectValue.name)
            }
            // 处理时间筛选
            if (
              [
                SEARCH_BOX_TYPE.DATE_SELECT,
                SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT,
              ].includes(subItem.type)
            ) {
              let find = subItem.options.find(
                optSubItem => optSubItem.value === OTHER_TYPE.CUSTOM_DATE
              )
              if (find) {
                if (subItem.selectValue === OTHER_TYPE.CUSTOM_DATE) {
                  this.$set(subItem, 'customDateStr', [
                    find?.defaultBeginDate?.replace(/-/g, '/'),
                    find?.defaultEndDate?.replace(/-/g, '/'),
                  ])
                }
                this.$set(subItem, 'curCustomDate', [
                  find.defaultBeginDate || '',
                  find.defaultEndDate || '',
                ])
              }
            }
            if ([SEARCH_BOX_TYPE.AREA].includes(subItem.type)) {
              this.$set(subItem, 'areaStr', '')
              this.$set(subItem, 'selectValue', [])
            }
            if (source === 'init') {
              // 处理联动项
              if ('groupId' in subItem) {
                // 存储联动的筛选项，方便后端处理
                this.linkageMap.set(subItem.groupId, subItem)
                // 联动筛选项赋值给筛选面板里面的项
                this.filterPanelOptsData.forEach((filterItem, filterIndex) => {
                  if ('groupId' in filterItem) {
                    if (
                      Number(subItem.groupId) === Number(filterItem.groupId)
                    ) {
                      filterItem = Object.assign({}, subItem, filterItem, {
                        label: subItem.selectLabel || filterItem.label, // 如果不是级联，则取回原来filter定义的label
                      })
                      this.$set(
                        this.filterPanelOptsData,
                        filterIndex,
                        filterItem
                      )
                    }
                  }
                })
              }
            }
          })
        })
        resolve()
      })
    },
    async reset() {
      await this.initData('reset')
      await this.$refs.filterPanelPopupRef.resetClick()
      await this.formatResult()
      return this.paramsResult
    },
    async resetClick() {
      if (typeof this.resetClickFn === 'function') {
        this.resetClickFn()
      } else {
        await this.reset()
        await this.search()
      }
    },
    exportBtn() {
      this.$emit('export', this.paramsResult)
    },
    extraCLick(subItem) {
      if (subItem.clickEvent && typeof subItem.clickEvent === 'function') {
        subItem.clickEvent()
      }
    },
    areaOpen(subItem, index = 0, subIndex = 0) {
      this.areaVisible = true
      this.currentAreaItem = {
        ...subItem,
        index: index,
        subIndex: subIndex,
      }
    },
    changeArea(area) {
      let areaStr = area.map(item => item.name).join(',')
      let areaCode = area.map(item => item.code)
      let optElement =
        this.opts[this.currentAreaItem.index][this.currentAreaItem.subIndex]
      this.$set(optElement, 'areaStr', areaStr)
      this.$set(optElement, 'selectValue', areaCode)
      // this.paramsResult[this.currentAreaItem.props] = areaCode
      this.search()
    },
    placeholder(item) {
      if (!item.multiple) {
        return (
          '请输入' +
          (
            item.options.filter(opt => opt.value === item.selectValue)[0] ||
            item.options[0]
          ).name +
          '搜索'
        )
      }
    },
    // 自定义时间确认
    handleConfirmDateTime(date) {
      let startTime = ''
      let endTime = ''
      switch (this.currentItem.dateType) {
        case DATE_TYPE.DATETIME:
          startTime = moment(date[0]).format('YYYY-MM-DD HH:mm:00')
          endTime = moment(date[1]).format('YYYY-MM-DD HH:mm:59')
          break
        default:
          startTime = date[0]
          endTime = date[1]
      }
      let startTimeStr = startTime.replace(/-/g, '/')
      let endTimeStr = endTime.replace(/-/g, '/')
      let optElement =
        this.opts[this.currentItem.index][this.currentItem.subIndex]
      this.$set(optElement, 'customDateStr', [startTimeStr, endTimeStr])
      this.$set(optElement, 'selectValue', OTHER_TYPE.CUSTOM_DATE)
      this.$set(optElement, 'curCustomDate', [startTime, endTime])
      this.paramsResult[this.currentItem.props] = [startTime, endTime]
      if ('groupId' in this.currentItem) {
        this.$refs.filterPanelPopupRef.changeFilterBox(
          this.currentItem.groupId,
          optElement.selectValue,
          optElement.curCustomDate,
          optElement
        )
      }
      this.search()
    },
    // 筛选面板确认
    filterPanelPopupConfirm(res, filterNumber) {
      this.filterNumber = filterNumber
      Object.assign(this.paramsResult, res)
      this.search()
    },
    mergeSearchparams(params) {
      console.log(params)
      Object.assign(this.paramsResult, params)
      this.search()
      // this.$emit('search', this.paramsResult)
    },
    // 筛选角标数字回调
    filterNumberChange(filterNumber) {
      this.filterNumber = filterNumber
    },
    // 联动筛选回调
    changeBox(groupId, selectedList, curCustomDate, item) {
      let groupItem = this.linkageMap.get(groupId)
      if ('labelOptions' in groupItem) {
        groupItem.selectLabelValue = item.filterSelectedLabelOpt
        let find = groupItem.labelOptions.find(
          opt => opt.value === item.filterSelectedLabelOpt
        )
        groupItem.selectLabel = find.name
      }
      // 自定义时间
      if (
        selectedList.length === 1 &&
        selectedList[0] === OTHER_TYPE.CUSTOM_DATE
      ) {
        groupItem.customDateStr = curCustomDate.map(item =>
          item.replace(/-/g, '/')
        )
        groupItem.selectValue = OTHER_TYPE.CUSTOM_DATE
        groupItem.curCustomDate = curCustomDate
      } else {
        groupItem.customDateStr = ''
        groupItem.selectValue = groupItem.multiple
          ? selectedList
          : selectedList[0]
      }
    },
    // 级联左侧下拉选择回调
    changeSelectLabel(subItem, val, name) {
      subItem.selectLabelValue = val
      subItem.selectLabel = name
    },
    // 下拉选择
    changeSelect(subItem, val) {
      if (subItem.multiple) {
        subItem.selectValue = val
      } else {
        subItem.selectValue = val
        subItem.customDateStr = ''
        subItem.searchValue = ''
        if ([SEARCH_BOX_TYPE.SELECT_INPUT].includes(subItem.type)) {
          let find = subItem.options.find(
            item => item.value === subItem.selectValue
          )
          this.$set(subItem, 'inputType', find.inputType ?? '') // selectInput筛选项 根据选择 切换输入框输入类型
        }
      }
      if ('groupId' in subItem) {
        this.$refs.filterPanelPopupRef.changeFilterBox(
          subItem.groupId,
          subItem.selectValue,
          '',
          subItem
        )
      }
      this.search()
    },
    // 自定义时间
    customDateChange(subItem, index = 0, subIndex = 0) {
      this.dateTimePopup = true
      this.currentItem = {
        ...subItem,
        index: index,
        subIndex: subIndex,
      }
    },
    // 聚焦
    handleFocus(item) {
      item.isFocused = true
    },
    // 失去焦点
    handleBlur(item) {
      setTimeout(() => {
        item.isFocused = false
      }, 300)
    },
    // 清空
    clear(item) {
      item.searchValue = ''
      this.$emit('clear', this.paramsResult)
      this.search()
    },
    areaClear(item) {
      item.areaStr = ''
      item.selectValue = []
      this.search()
    },
    // 搜索
    search: debounce(async function () {
      console.log('ssssssssssss', this.subItem)
      await this.formatResult()
      this.$emit('search', this.paramsResult)
    }, 200),
    // 格式化结果数据
    async formatResult() {
      try {
        let filterRes = await this.$refs.filterPanelPopupRef.getData()
        return new Promise(resolve => {
          let res = {}
          this.opts.forEach(item => {
            item.forEach(subItem => {
              if (
                subItem.type === SEARCH_BOX_TYPE.SELECT ||
                subItem.type === SEARCH_BOX_TYPE.AREA
              ) {
                res[subItem.props] = subItem.selectValue
              } else if (subItem.type === SEARCH_BOX_TYPE.SELECT_INPUT) {
                subItem.props = subItem.selectValue
                res[subItem.props] = subItem.searchValue
              } else if (subItem.type === SEARCH_BOX_TYPE.NORMAL_INPUT) {
                res[subItem.props] = subItem.searchValue
              } else if (subItem.type === SEARCH_BOX_TYPE.DATE_SELECT) {
                if (subItem.selectValue === OTHER_TYPE.CUSTOM_DATE) {
                  res[subItem.props] = subItem.curCustomDate
                } else {
                  res[subItem.props] = subItem.selectValue
                }
              } else if (subItem.type === SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT) {
                subItem.props = subItem.selectLabelValue
                if (subItem.selectValue === OTHER_TYPE.CUSTOM_DATE) {
                  res[subItem.props] = subItem.curCustomDate
                } else {
                  res[subItem.props] = subItem.selectValue
                }
                if (subItem.selectLabelKey) {
                  res[subItem.selectLabelKey] = subItem.props
                }
              }
            })
          })
          this.paramsResult = Object.assign({}, filterRes, res)
          console.log('paramsResult', this.paramsResult)
          resolve(this.paramsResult)
        }).catch(e => {
          throw e
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 获取参数
    getParams() {
      return this.paramsResult
    },
    // 获取参数（promise）
    async getParamsAsync() {
      try {
        await this.formatResult()
        return this.paramsResult
      } catch (e) {
        console.log(e)
      }
    },
    async setDefaultOptions(paramsResult) {
      for (const paramsResultKey in paramsResult) {
        let subItem = this.optsPropsMap.get(paramsResultKey)
        if (!subItem) continue
        switch (subItem.type) {
          case SEARCH_BOX_TYPE.NORMAL_INPUT:
            this.$set(subItem, 'searchValue', paramsResult[paramsResultKey])
            break
          case SEARCH_BOX_TYPE.SELECT_INPUT:
            this.$set(subItem, 'selectValue', paramsResultKey)
            this.$set(subItem, 'searchValue', paramsResult[paramsResultKey])
            break
          case SEARCH_BOX_TYPE.SELECT:
            this.$set(subItem, 'selectValue', paramsResult[paramsResultKey])
            if ('groupId' in subItem) {
              this.$refs.filterPanelPopupRef.changeFilterBox(
                subItem.groupId,
                subItem.selectValue,
                '',
                subItem
              )
            }
            break
          case SEARCH_BOX_TYPE.DATE_SELECT:
            for (let i = 0; i < subItem.options.length; i++) {
              let isEqual = arraysAreEqual(
                paramsResult[paramsResultKey],
                subItem.options[i].value
              )
              if (isEqual) {
                this.$set(subItem, 'selectValue', paramsResult[paramsResultKey])
                this.$set(subItem, 'customDateStr', '')
                break
              } else if (subItem.options[i].value === OTHER_TYPE.CUSTOM_DATE) {
                this.$set(subItem, 'selectValue', OTHER_TYPE.CUSTOM_DATE)
                this.$set(
                  subItem,
                  'curCustomDate',
                  paramsResult[paramsResultKey]
                )
                this.$set(
                  subItem,
                  'customDateStr',
                  paramsResult[paramsResultKey].map(item =>
                    item.replace(/-/g, '/')
                  )
                )
              }
            }
            if ('groupId' in subItem) {
              this.$refs.filterPanelPopupRef.changeFilterBox(
                subItem.groupId,
                subItem.selectValue,
                subItem.curCustomDate,
                subItem
              )
            }
            break
          case SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT:
            // 这里是时间变量不存在或者是个空数组
            if (
              !paramsResult[paramsResultKey] ||
              (Array.isArray(paramsResult[paramsResultKey]) &&
                !paramsResult[paramsResultKey].length)
            ) {
              break
            }
            for (let i = 0; i < subItem.labelOptions.length; i++) {
              if (paramsResultKey === subItem.labelOptions[i].value) {
                this.$set(
                  subItem,
                  'selectLabelValue',
                  subItem.labelOptions[i].value
                )
                this.$set(subItem, 'selectLabel', subItem.labelOptions[i].name)
                break
              }
            }
            // 是否有命中选项的
            let hasHit = false
            for (let i = 0; i < subItem.options.length; i++) {
              let isEqual = arraysAreEqual(
                paramsResult[paramsResultKey],
                subItem.options[i].value
              )
              if (isEqual) {
                hasHit = true
                this.$set(subItem, 'selectValue', paramsResult[paramsResultKey])
                this.$set(subItem, 'customDateStr', '')
                break
              } else if (
                subItem.options[i].value === OTHER_TYPE.CUSTOM_DATE &&
                !hasHit
              ) {
                this.$set(subItem, 'selectValue', OTHER_TYPE.CUSTOM_DATE)
                this.$set(
                  subItem,
                  'curCustomDate',
                  paramsResult[paramsResultKey]
                )
                this.$set(
                  subItem,
                  'customDateStr',
                  paramsResult[paramsResultKey].map(item =>
                    item.replace(/-/g, '/')
                  )
                )
              }
            }
            if ('groupId' in subItem) {
              this.$refs.filterPanelPopupRef.changeFilterBox(
                subItem.groupId,
                subItem.selectValue,
                subItem.curCustomDate,
                subItem
              )
            }
            break
          case SEARCH_BOX_TYPE.AREA:
            break
        }
      }
      this.$refs.filterPanelPopupRef.setDefaultFilterOptions(paramsResult)
      const res = await this.formatResult()
      return res
    },
  },
}
</script>

<style scoped lang="scss">
@import './css/mixin.scss';
.van-row {
  margin-bottom: 11px;
  &:last-child {
    margin-bottom: 0;
  }
}
input {
  color: #202124;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &::placeholder {
    color: #b8babf;
  }
}
.search-box-container {
  width: 100%;
  * {
    box-sizing: border-box;

    &::before,
    &::after {
      box-sizing: border-box;
    }
  }
}
.normal-input-box {
  @include common-input-box;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
}
.select-input-box {
  @include common-input-box;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
  .line {
    width: 1px;
    height: 23px;
    background: #f5f7fa;
  }
}
.select-box {
  @include common-box;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
  .van-popover__wrapper {
    overflow: hidden;
  }
}
.area-box {
  @include common-box;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
  .area-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  img {
    width: 8px;
    height: 6px;
    transition: transform 0.3s;
    transform: rotate(0);
  }
}
.filter-box {
  @include common-box;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
  img {
    width: 8px;
    height: 6px;
    transition: transform 0.3s;
    transform: rotate(0);
  }
}
.reset-box {
  @include common-box;
  @include flex($justify: center, $align: center, $gap: 8px);
  color: $--font-color-base;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
}
.export-box {
  @include common-box;
  @include flex($justify: center, $align: center, $gap: 8px);
  color: $--font-color-base;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
}
.extra-box {
  @include common-box;
  @include flex($justify: center, $align: center, $gap: 8px);
  color: $--font-color-base;
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
}
.extra-slot-box {
  @include common-box;
  @include flex($justify: center, $align: center, $gap: 8px);
  @include when(small-size) {
    height: $--height-small;
    padding: $--padding-vertical-small $--padding-horizontal-base;
  }
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep {
  .van-badge__wrapper {
    display: block;
  }
  .van-badge--fixed {
    top: 3px;
    right: 5px;
  }
}
</style>
